import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { PrimeNGUIModules } from './primeng-ui.module';
import { SharedComponent } from './shared.component';
import { SectionSkeletonComponent } from './section-skeleton/section-skeleton.component';
import { SkeltonComponent } from './skelton/skelton.component';
import { PriceRoundPipe } from './pipes/price-round.pipe';
import { DynamicRoundPipe } from './pipes/dynamic-round.pipe';
import { SkeletonModule } from 'primeng/skeleton';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { WebsiteAttributesService } from './services/website-attributes.service';
import { AppProductNamePipe } from './pipes/app-product-name.pipe';
import { FacebookPixelService } from './services/analytics-services/facebook-pixel/facebook-pixel.service';
import { GoogleAnalyticsService } from './services/analytics-services/google-analytics/google-analytics.service';
import { LoadPixelAdService } from './services/analytics-services/load-pixel-ad/load-pixel-ad.service';
import { TiktokPixelService } from './services/analytics-services/tiktok-pixel/tiktok-pixel.service';
import { CommonModule } from '@angular/common';
import { SharedFacade } from './domain/facades/shared.facades';
import { LanguagePipe } from './pipes/language.pipe';
import { BaseComponent } from './components/BaseComponent';
import { BaseService } from './services/BaseService';
import { HomeSectionSkeletonComponent } from './components/home-section-skeleton/home-section-skeleton.component';
import { ProfileOrdersSkeletonComponent } from './components/profile-orders-skeleton/profile-orders-skeleton.component';
import { BannerSkeletonComponent } from './components/banner-skeleton/banner-skeleton.component';
import { ImaToastComponent } from './components/ima-toast/ima-toast.component';
import { Validation_Directive } from './directives/validation.directive';



@NgModule({
  declarations: [
    SharedComponent,
    SectionSkeletonComponent,
    SkeltonComponent,
    PriceRoundPipe,
    DynamicRoundPipe,
    AppProductNamePipe,
    LanguagePipe,
    BaseComponent,
    HomeSectionSkeletonComponent,
    ProfileOrdersSkeletonComponent,
    BannerSkeletonComponent,
    ImaToastComponent,
    Validation_Directive
  ],
  imports: [
    CommonModule,
    CarouselModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PrimeNGUIModules,
    SkeletonModule,
    CarouselModule,
    LazyLoadImageModule
  ],
  exports: [
    CommonModule,
    SharedComponent,
    DynamicRoundPipe,
    CarouselModule,
    PrimeNGUIModules,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    PriceRoundPipe,
    AppProductNamePipe,
    CarouselModule,
    SectionSkeletonComponent,
    LanguagePipe ,
    BaseComponent,
    HomeSectionSkeletonComponent,
    ProfileOrdersSkeletonComponent,
    BannerSkeletonComponent,
    ImaToastComponent,
    Validation_Directive
  ],
  providers: [
    BaseService,
    FacebookPixelService,
    GoogleAnalyticsService,
    LoadPixelAdService,
    TiktokPixelService,
    SharedFacade,

  ]
})
export class SharedModule {}
